export default __webpack_public_path__ + "static/270-c18c0d34b7e5c860545da58bb406529f.gif";